// extracted by mini-css-extract-plugin
export default {"navlink":"setting_navlink__fHE-3","active":"setting_active__Dw++3"};